'use strict'
require("babel-polyfill");
// var colorify = require('colorify.js');
import 'objectFitPolyfill';
import Swiper from 'swiper/bundle'
import SmoothScroll from './_SmoothScroll.js'
import ScrollHelper from './_ScrollHelper.js'
import ResizeHelper from './_ResizeHelper.js'

$(() => {
  const $window = $(window);
  const $body = $('body');
  $body.addClass('loaded');

  let windowHeight = window.innerHeight;
  const resizeHelper = new ResizeHelper(() => {
    windowHeight = window.innerHeight;
  })
  const scrolled = new ScrollHelper(function(){
    $body.toggleClass('scrolled', $(window).scrollTop() >= windowHeight * .25);
  });

  new Swiper('.mv-slider', {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    speed: 12000,
    centeredSlides: true,
    noSwiping: true,
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  })


  $('.js-toggle-flow').on('click', () => {
    $body.toggleClass('flow-active')
  })



  $('.qa_item').each(function(){
    $(this).find('.qa_toggle').on('click', (e) => {
      // console.log(e.currentTarget);
      const $this = $(this);
      $this.toggleClass("active")
      $this.find('dd').slideToggle();
    });
    $(this).find('a').on('click', (e) =>{
      e.stopPropagation();
    });
  })

  $('#header-toggle').on('click', () => {
    $('body').toggleClass('menu_active');
    // $('.submenu').hide();
    $('#navigation li').removeClass('active');
  })




  // smooth scroll ------------------------------------------------------------
  function scrollTo(top){
    $('html,body').animate({ scrollTop: top }, {'easing': 'swing', 'duration': 500});
  }
  function calcScrollTo($el){
    // const offset = $('#nav').outerHeight() || 100;
    const offset = 0;
    // console.log($('#nav').height())
    // console.log($('#nav').outerHeight())
    if($el.length){
      var to = $el.offset().top
    }else{
      var to = 0;
    }
    return to - offset;
  }
  $('a[href ^= "#"]').click(function(e){
    const $this = $(this);
    const id = $this.attr('href');
    if(id === '#') return false;
    const $el = $(id);
    scrollTo(calcScrollTo($el));

    if($this.hasClass('nohash')){
      e.preventDefault();
    }
    e.stopPropagation();
  });
});
